import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ProjektArtsQuerySorterConfig } from 'fa-kt.types';
import { ProjektArtsService } from '../service';

@Component({
  selector: 'fa-kt-projekt-arts-sorter',
  templateUrl: './projekt-arts-sorter.component.html',
  styleUrls: ['./projekt-arts-sorter.component.css'],
})
export class ProjektArtsSorterComponent {
  ProjektArtsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public projektArts: ProjektArtsService,
  ) {
    this.ProjektArtsSorterConfig = ProjektArtsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
